<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2020-11-29 18:38:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div
    class="BaomingSuccess2"
    :style="
      `background: url('${require('../assets/baoming2/bg.jpg')}'); background-size: 100% 100%;`
    "
  >
    <img class="sub-logo2" src="../assets/baoming2/logo.png" />
    <div class="content">
      <div class="body">
        <div class="top">
          <img src="../assets/baoming2/title.png" class="topImg" />
        </div>
        <div class="registered">
           <div class="qrcode">
                        <img :src="qrcode" class="qrcodeImg">
                    </div>
                    <!-- <div class="tip">
                        <img src="../assets/baomingTip.png" class="tipImg">
                    </div> -->
        </div>
        <div class="bottom2">
          <img src="../assets/baoming2/bottom.png" class="bottomImg" />
        </div>
      </div>
    </div>

    <share></share>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "BaomingClose2",
  data() {
    return {
      qrcode: "",
      openid: "",
      meetid: 10 // 会议ID
    };
  },

  methods: {
    // 获取二维码
    getRrcode() {
        let data = {}
        data.meetid = this.$route.query.id
        data.type = 2
        Http.post(api.getQrcode, data).then((response) => {
            this.qrcode = response.data.thumb
        });
        return false;
    },
  },
  mounted: function() {
    document.title = '走进西部'
    this.openid = Cookies.get("openid");
    // 跳转到首页
    // if (!this.openid) {
    //   this.$router.push({ name: "Baoming2" });
    // }
    this.getRrcode()
  },
};
</script>

<style lang="less">
.BaomingSuccess2 {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  //  background-color: #041d34;
  min-height: 100vh;
  .sub-logo2 {
    position: absolute;
    width: 40px;
    top: 20px;
    left: 20px;
  }
  .content {
    position: relative;
    min-height: 100vh;
    .top {
      margin: 52px auto 0;
      width: 90%;
      .topImg {
        width: 100%;
      }
    }

    .qrcode {
         margin: 0 auto;
         width: 50%;
        .qrcodeImg {
            width: 100%;
        }
    }
    .tip {
         margin: 0 auto;
          width: 64%;
        .tipImg {
            width: 100%;
        }
    }
    
    .bottom2 {
      margin-top: 12px;
      position: fixed;
      bottom: 0px;
      .bottomImg {
        width: 100%;
      }
    }
    .bottom3 {
      margin-top: 12px;
      .bottomImg {
        width: 100%;
      }
    }
    .registered {
      border-radius: 4px;
      box-sizing: border-box;
      padding: 0 20px;
      width: 90%;
      margin: auto;
      .title {
        margin-top: 20px;
        margin-bottom: 28px;
        font-size: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
        color: #0c0c0c;
      }
      .van-cell {
        align-items: center;
        //   border-bottom: 1px solid #dcdcdc;
        font-size: 14px;
        margin-top: 10px;
      }
      .van-field__control {
        //    color: #fff;
      }
      ::-webkit-input-placeholder {
        color: #072d47;
      }
      .van-cell__value {
        margin-left: 12px;
      }
      .van-cell {
        margin-top: 0px;
        background-color: transparent;
      }
      .van-field__label {
        width: 30px;
        font-size: 14px;
        color: #0c0c0c;
      }

      .van-cell:not(:last-child)::after {
        border-bottom: 0px;
      }
      .tip {
        font-size: 12px;
        color: #0c0c0c;
      }
      .bottom {
        margin-bottom: 30px;
        .confirm {
          width: 200px;
          //   height: 40px;
          //   border-radius: 18px;
          //   font-size: 18px;
          //   background-color:#041f39;
          //     border: 1px solid #74a2ce;
          //     color: #2d6d9c;
        }
      }
    }
    .custom_input_style {
      // color: #fff;
      border-bottom: 1px solid #0c0c0c;
    }
    .input-class {
      opacity: 0.8;
      border-bottom: 0;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaomingClose2.vue